import React from 'react';
import { useNavigate } from 'react-router-dom';

import Panel from '../../components/Panel';
import Image from '../../assets/svg/panelImage.svg';
import AuthService from '../../services/AuthService';
import { gtmAttributesUpdateComplianceErrorPage } from '../../utils/gtmVariables';
import useGTMEventsTracker from '../../hooks/useGTMEventsTracker';
import Typography from '../../components/Typography';

const InvalidCNPJ = () => {
  const navigate = useNavigate();
  const gtmEventsTracker = useGTMEventsTracker();

  gtmEventsTracker(gtmAttributesUpdateComplianceErrorPage);

  const logout = () => {
    AuthService.logout();
    navigate('/', { replace: true });
  };

  return (
    <Panel
      title="Inconsistência no CNPJ cadastrado"
      description={<>Para continuar seu cadastro, faça seu login.</>}
      panelType="confirmation"
      buttonText="Fechar e sair"
      image={Image}
      onClick={logout}
      className="invalid-cnpj-panel"
      buttonId="mp__invalid-cnpj_understood-button"
    >
      <Typography as="p" variant="body2" className="text-neutral-darkest leading-6 mb-6">
        Orientamos que você procure a Receita Federal pra entender o motivo dessa inconsistência.
      </Typography>
      <Typography as="p" variant="body2" className="text-neutral-darkest leading-6 mb-6">
        Com isso resolvido, entre em contato conosco para fazer o cadastro.
      </Typography>
    </Panel>
  );
};

export default InvalidCNPJ;
